module.exports = __webpack_public_path__ + "static/media/Magnemite_gaussian2.b2b8ace1.png";